const NotSet = () => <span style={{ color: "#8C8C8C" }}>Not-Set</span>;
export default NotSet;
